import React from 'react';
import { imageUrl } from '../../api/image';

/**
 * An off-app broadcast's partner (`watch_on`: `{platform_name, logo, url}`, bkfc-cms media.md):
 * "Watch on <partner>" opening `url` in a new tab, or naming the partner when there is no link.
 * `badge` is the small card form: a label only, because the card itself is the link.
 */
const WatchOn = ({ watchOn, className = 'events-hero-btn-tertiary', badge = false }) => {
  const logo = imageUrl(watchOn.logo, 'fit', 160);
  const body = (
    <span className="inline-flex items-center gap-2">
      {logo && <img src={logo} alt="" className={badge ? 'h-4' : 'h-6'} />}
      {badge ? watchOn.platform_name : `Watch on ${watchOn.platform_name}`}
    </span>
  );
  if (badge) {
    return (
      <span
        className="inline-flex items-center bg-black/80 text-white text-xs font-bold uppercase tracking-wide px-2 py-0.5 rounded"
        data-testid="watch-on-badge"
      >
        {body}
      </span>
    );
  }
  return watchOn.url ? (
    <a href={watchOn.url} target="_blank" rel="noopener noreferrer" className={className}>
      {body}
    </a>
  ) : (
    <span className={className} data-testid="watch-on">
      {body}
    </span>
  );
};

export default WatchOn;
